import React from 'react'
import { Outlet } from 'react-router-dom'

export const VechilesegmentBase: React.FC = () => {
  return <Outlet />
}
